const AiServiceOCRActivity = () => {
  return (
    <>
      <div className="container mx-auto pt-10">
        <h1 className="mb-2 text-2xl font-bold">OCR Activity</h1>
        <p className="mb-8 text-muted-foreground">
          Track your OCR usage and see how it's being used.
        </p>

        <h2 className="text-lg font-semibold">Recent Activity</h2>
      </div>
    </>
  );
};

export default AiServiceOCRActivity;
